// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../../engines/gameEngine";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import CsvDataManage from "../../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../../define/CsvFileKind";
import { FileKind } from "../../../../define/FileKind";
import SettleLawsuitLayer from "../common/SettleLawsuitLayer";
import SettleLawsuitSpecialDetail from "./SettleLawsuitSpecialDetail";
import SettleLawsuitSpecialPeopleNode from "./SettleLawsuitSpecialPeopleNode";

const {ccclass, property} = cc._decorator;

/** 自己说话背景和文字位置差 */
const c_selfTalkSpaceY = 76;
@ccclass
export default class SettleLawsuitSpecialLayer extends SettleLawsuitLayer {

	@property({ type: cc.Node, displayName:'' })
	nodePeopleList: cc.Node = null;

    @property(cc.Prefab)
    prefabPeople: cc.Prefab = null;

    @property(cc.Prefab)
    prefabDetail: cc.Prefab = null;

    @property(cc.Prefab)
    prefabSelect: cc.Prefab = null;

	@property({ type: cc.Button, displayName:'' })
	btnDetail: cc.Button = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalkSelf: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalkSelf: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	sprTalkBg: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	sprDetailLight: cc.Node = null;

    private csvInfo: any = null;
    /** 最小高度 */
    private minTalkHeight = 0;

    /** 人物id组 */
    private peopleArr: string[] = [];

    private specialDetailScript: SettleLawsuitSpecialDetail = null;

    private bEndGame = false;
    
    start () {
        this.minTalkHeight = this.sprTalkBg.height;

        this.setSlefTalkShow(false);
        this.setBtnDetailAni(false);
        this.initLayer();
    }

    initLayer() {
        let id = this._carryData.id;
        this.csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.LEGAL_CASE_SPECIAL, id);
        if (!this.csvInfo) {
            console.error(`数据获取失败`);
            return;
        }
        this.initPeopleArr();

        this.resetData();
    }

    resetData() {
        this.btnDetail.interactable = true;
        this.bEndGame = false;
        this.openDetailLayer(false);
    }

    initPeopleArr() {
        let people: string = this.csvInfo.people.trim();
        let splits = utilsModel.splitLineFeed(people);
        // for (let i = 0; i < splits.length; i++) {
        //     let peopleId = CsvDataManage.instance.getPeopleArrayRandomId(splits[i]);
        //     if (!peopleId) {
        //         console.error(`人物获取错误`);
        //         continue;
        //     }
        //     if (this.peopleArr.includes(peopleId)) {
        //         i--;
        //         continue;
        //     }
        //     this.peopleArr.push(peopleId);
        // }
        this.peopleArr = splits;
        this.initPeopleUI();
    }

    initPeopleUI() {
        this.nodePeopleList.getComponent(cc.Layout).spacingX = this.peopleArr.length > 2 ? 30 : 80;
        for (let i = 0; i < this.peopleArr.length; i++) {
            let o = this.peopleArr[i];
            let nodePeople = cc.instantiate(this.prefabPeople);
            let peopleScript = nodePeople.getComponent(SettleLawsuitSpecialPeopleNode);

            let strTalk: string = this.csvInfo['answer' + (i+1)];
            peopleScript.setCarryData({
                id: o
                , strTalk: strTalk
                , parent: this
            });
            this.nodePeopleList.addChild(nodePeople);
        }
    }

    closeAllPeopleTalk() {
        this.nodePeopleList.children.forEach((v)=> {
            let peopleScript = v.getComponent(SettleLawsuitSpecialPeopleNode);
            peopleScript.hideTalk();
        });
    }

    setBtnDetailAni(visible: boolean) {
        cc.Tween.stopAllByTarget(this.sprDetailLight);
        if (visible) {
            this.sprDetailLight.active = true;

            // cc.tween(this.sprDetailLight)
            // .blink(1.3, 1)
            // .repeatForever()
            // .start();
            const time = 0.5;
            this.sprDetailLight.opacity = 0;
            cc.tween(this.sprDetailLight)
            .to(time, {opacity: 255})
            .delay(0.8)
            .to(time, {opacity: 0})
            .union()
            .repeatForever()
            .start();
        } else {
            this.sprDetailLight.active = false;
        }
    }

    onClickDetail() {
        // if (!this.sprDetailLight.active) {
        //     return;
        // }
        // this.showSelfTalk(1, 0);
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.openDetailLayer(true);
    }

    setSlefTalkShow(visible: boolean) {
        this.nodeTalkSelf.active = visible;
    }

    showSelfTalk(peopleIdx: number, selectIdx: number, bSuccess: boolean) {
        let strTalkArr: string = this.csvInfo['select_judgment_' + peopleIdx];
        if (!strTalkArr) {
            console.error(`数据错误`);
            return;
        }
        let splits = utilsModel.splitLineFeed(strTalkArr);
        let strTalk = splits[selectIdx];
        if (!strTalk) {
            console.error(`数据错误`);
            return;
        }
        cc.Tween.stopAllByTarget(this.sprTalkBg);
        this.setSlefTalkShow(true);

        this.labelTalkSelf.string = strTalk;
        utilsView.refreshLabelUI(this.labelTalkSelf);
        let height = this.labelTalkSelf.node.height;
        height = Math.max(height + c_selfTalkSpaceY, this.minTalkHeight);
        this.sprTalkBg.height = height;
        this.labelTalkSelf.node.getComponent(cc.Widget).updateAlignment();


        const time = 0.25;
        this.sprTalkBg.opacity = 0;
        cc.tween(this.sprTalkBg)
        .to(time, {opacity: 255})
        .delay(2.5)
        .to(time, {opacity: 0})
        .call(()=> {
            this.showResultUI(bSuccess);
        })
        .start();
    }

    showResultUI(bSuccess: boolean) {
        if (bSuccess) {
            let retArr = utilsModel.splitLineFeed(this.csvInfo.success);
            this.openSuccessLayer(retArr, FileKind.PrefabFilePath.SettleLawsuitSpecialSuccessLayer);
        } else {
            let retArr = utilsModel.splitLineFeed(this.csvInfo.lose);
            this.openLoseLayer(retArr, FileKind.PrefabFilePath.SettleLawsuitSpecialLoseLayer);
        }
    }

    openDetailLayer(bCanClick: boolean) {
        if (!this.specialDetailScript) {
            let node = cc.instantiate(this.prefabDetail);
            this.specialDetailScript = node.getComponent(SettleLawsuitSpecialDetail);
            this.specialDetailScript.setCarryData({
                parent: this
                , csvInfo: this.csvInfo
                , peopleArr: this.peopleArr
            });
            this.node.addChild(node);
        }
        this.specialDetailScript.setShow(true);
        this.specialDetailScript.setCanClick(bCanClick);
    }

    onClickSelect(idx: number) {

        let selectArr: string = this.csvInfo['select' + (idx+1)];
        if (!selectArr) {
            console.error(`数据错误`);
            return;
        }
        let node = cc.instantiate(this.prefabSelect);
        let script = node.getComponent(BasePopUpLayer);
        script.setCarryData({
            parent: this
            , idx: idx
            , selectArr: selectArr
        });
        this.node.addChild(node);
    }

    onClickSelectJudgment(
        idxPeople: number
        , idxJudgment: number
        , bSuccess: boolean
    ) {
        this.showSelfTalk(idxPeople+1, idxJudgment, bSuccess);
        this.setBtnDetailAni(false);
        this.btnDetail.interactable = false;
        this.bEndGame = true;
    }   
}
